import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { getDeviceRegitration } from '../../../../../../actions/SelectDevice';
import DisplayUpdateConfirmationWithList from '../../../../../../components/EditMyAccount/DisplayUpdateConfirmationWithList/DisplayUpdateConfirmationWithList';
import { routePath } from '../../../../../../constants/Routes';
import deviceOffline from '../../../../../../assets/images/printer-offline.svg';
import { pushDataLayer, updateDeviceInfoToLocalStorage } from '../../../../../../constants/AppMethod';
import Loader from '../../../../../../components/shared/loader/Loader';
import { BMC_ENROLMENT_TYPE, ECOPROTOKEN_CLAIMS, LOCALSESSIONDATAKEYS, refreshBtn } from '../../../../../../constants/AppConstants';
import DisplayUpdateAccountConfirmation from '../../../../../../components/EditMyAccount/DisplayUpdateAccountConfirmation/DisplayUpdateAccountConfirmation';
import ErrorPage from '../../../../../../components/shared/errorPage/ErrorPage';
import { getLocalSessionData, getUserSessionData } from '../../../../../../utils/Authentication/handleUserSession';
import { useHistory } from 'react-router-dom';
import { Redirect } from 'react-router-dom/cjs/react-router-dom.min';
import UseCheckNetworkStatus from '../../../../../../utils/CustomHooks/UseCheckNetworkStatus';
import { USE_NOT_ENROLLED_DEVICE_LIST } from '../../../../../../components/Redirection/BMCDeviceEnrollmentCheck';
import { useAppNavigation } from '../../../../../../utils/CustomHooks/useAppNavigation';

const WebAddMyDevice = (props) => {
    const { t } = useTranslation(["translation"]);
    const dispatch = useDispatch();
    const history = useHistory();
    const { type = null, subscriptionKind } = props?.location?.state || {};
    const {
        offlineStatus,
        oneTimeRecheck,
        onConfirmDeviceClick,
        callBMCRedirection,
        setOfflineStatus,
        setOneTimeRecheck,
        setConfirmDeviceClick,
        setBMCRedirection,
        recheckNetworkStatus
    } = UseCheckNetworkStatus();

    const { goToWebPlaceOrder } = useAppNavigation();

    const deviceCapabilityResult = useSelector((state) => state.DeviceCapability)
    const deviceListRecheckResult = useSelector((state) => state.SelectDevice);
    const [deviceList, setDeviceList] = useState([]);
    const [devicInfo, setDeviceInfo] = useState(
      { 
        model : null, 
        serialNumber: null, 
        imagePath: null, 
        networkStatus: null
      });

    const {
      loading: deviceListLoading,
      unEnrolledDevicesList: deviceListNotYetEnrolled, 
      deviceList: deviceListAPIResp, 
      success: deviceListsuccess, 
      error: deviceListErr
    } = deviceListRecheckResult || {};

    const UID = getUserSessionData(ECOPROTOKEN_CLAIMS.USERID);
    const deviceId = getLocalSessionData(LOCALSESSIONDATAKEYS.DEVICE_ID);
    const deviceRegistrationResult = useSelector((state) => state.DeviceRegistration)

    useEffect(() => {
      if(deviceList?.length === 0){
        if(type && type === USE_NOT_ENROLLED_DEVICE_LIST){
          setDeviceList(deviceListNotYetEnrolled)
        } else {
          setDeviceList(deviceListAPIResp?.devices);
        }
      }
      if(deviceList?.length > 0){
          const deviceKeysToSessionMap = {
            model: LOCALSESSIONDATAKEYS.DEVICE_MODEL,
            serialNumber: LOCALSESSIONDATAKEYS.SERIAL_NUMBER,
            printerType: LOCALSESSIONDATAKEYS.PRINTER_TYPE,
          };
          setDeviceInfo(prev => ({
            ...prev,
            model: deviceList[0]?.model,
            serialNumber: deviceList[0]?.serialNumber,
            imagePath: deviceList[0]?.imagePath,
            networkStatus: deviceList[0]?.networkStatus

          }));
        updateDeviceInfoToLocalStorage(deviceList[0], deviceKeysToSessionMap);
      }
      // eslint-disable-next-line
    }, [deviceListsuccess, deviceList]);
   
    const onConnectThisDevice = () => {
      if(devicInfo.networkStatus === "online"){
        dispatch(getDeviceRegitration(UID, deviceId))
      }
      else if(devicInfo.networkStatus === "offline"){
        setOfflineStatus(true)
      }
      setConfirmDeviceClick(true)
      pushDataLayer('connect_device',"device_id",deviceId)
    }

    useEffect(()=>{
      if(deviceRegistrationResult.success && onConfirmDeviceClick){
        setConfirmDeviceClick(false)
        goToWebPlaceOrder({subscriptionKind})
      }
       // eslint-disable-next-line
    },[deviceRegistrationResult.success,history, onConfirmDeviceClick])

    if(deviceRegistrationResult.error){
      return (
        <ErrorPage
          errorInfo={deviceRegistrationResult.error}
          showRefreshBtn={refreshBtn.HIDE}
          ></ErrorPage>
      )
    }
    if (deviceListErr) {
      return (
        <ErrorPage
          errorInfo={deviceListErr}
          showRefreshBtn={refreshBtn.HIDE}
        ></ErrorPage>
      );
    }
    if (deviceListsuccess && deviceList?.length === 0) {
      return (
        <ErrorPage
          errorInfo={t("ERROR_CONTENT.NO_DEVICES")}
          showRefreshBtn={refreshBtn.HIDE}
        ></ErrorPage>
      );
    }
  
    if (deviceListsuccess && deviceList?.length > 0){
      deviceList.map((device) =>{
          let selectedDeviceId;
          if(deviceId){
            selectedDeviceId = deviceId
          }
          else{
            selectedDeviceId = getLocalSessionData(LOCALSESSIONDATAKEYS.DEVICE_ID)
          }
          if(device.deviceId === selectedDeviceId){
            devicInfo.networkStatus = device.networkStatus
            if(device.networkStatus === "online" && oneTimeRecheck){
              dispatch(getDeviceRegitration(UID, deviceId))
              setOneTimeRecheck(false);
              setBMCRedirection(false);
            }
          }
          return device;
        })
    }

   

    if(deviceCapabilityResult.loading || deviceListLoading|| deviceRegistrationResult.loading) {
      return <Loader></Loader>
    }

    let deviceDataForPlans = {
      'deviceId':deviceId,
      'device_model': devicInfo.model,
      'serialNumber':devicInfo.serialNumber,
      'networkStatus':devicInfo.networkStatus
    }

    /**
     * If device status is offline, the offline content will be displayed
     * On retry the updated device info should be fetched, so this component is called to evaluate the latest       device info.
     */
    if(callBMCRedirection){
      return <Redirect to= {{pathname: routePath.PROCESS_DEVICE, state: {
        source: BMC_ENROLMENT_TYPE.BMC_AS_POST_ENROLLMENT_SERVICE,
        subscriptionKind: subscriptionKind
      }}}/>
    }

    if(offlineStatus){
      return <DisplayUpdateAccountConfirmation
        updateAddressHeader={t("DEVICE_STATUS_CHECK.OFFLINE_STATUS_HEADER")}
        updateAddressInfo={t("DEVICE_STATUS_CHECK.OFFLINE_STATUS_INFO")}
        updateAddressBtn={t("ECOPRO_BTNS.RETRY")}
        onUpdateClick = {()=>recheckNetworkStatus()}
        image={deviceOffline}
        ></DisplayUpdateAccountConfirmation>
    }
    return (
      <>
        {
          (callBMCRedirection)
          ? <Loader />
          : <div>
            <DisplayUpdateConfirmationWithList
              account="swapDevice"
              header={t("CUSTOMER_WEB.ADD_MY_DEVICE.HEADER")}
              subHeader={t("CUSTOMER_WEB.ADD_MY_DEVICE.SUB_HEADER", {model:devicInfo.model})}
              imagePath={devicInfo.imagePath}
              model={devicInfo.model}
              serialNumber={devicInfo.serialNumber}
              btnText={t("CUSTOMER_WEB.ADD_MY_DEVICE.CONNECT_DEVICE")}
              linkUrl={routePath.PLANS}
              linkWithState={deviceDataForPlans}
              linkText={t("CUSTOMER_WEB.ADD_MY_DEVICE.CHANGE_SUBSCRIPTION")}
              onBtnClick={onConnectThisDevice}
              onUpdateBtnID="connect_device"
            ></DisplayUpdateConfirmationWithList>  
          </div>
        }
      </>
    );
};

export default WebAddMyDevice;